import {Component} from '@angular/core';
import {AuthUserService} from "@common-module/app-services/auth-user.service";
import {Tab} from "@common-module/app-enums/tab";

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html'
})
export class LogoutComponent {

  constructor(
    private readonly authUserService: AuthUserService,
  ) {
  }

  ngOnInit(): void {
    this.authUserService.logout([Tab.MAIN]);
  }

}
